package org.example.project.service

import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.enginetabular.loadWithTabularFilters
import org.example.project.utils.All

object MeineFahrzeugeApi {
    const val TYP_ZUGMASCHIENE = "zugmaschiene"
    const val TYP_AUFLIEGER = "auflieger"

    private const val EMPTY_FIELD = "~"

    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun load(type: String, firmenId: String = currentFirmenId()): List<All> =
        decodeList(LumaticaApiManager.call(route("list", firmenId, type)))

    suspend fun search(type: String, filters: Map<String, String>): List<All> =
        decodeList(loadWithTabularFilters("meinefahrzeuge/search/~/${apiPart(type)}", filters))

    suspend fun save(type: String, data: All, firmenId: String = currentFirmenId()): All? =
        decodeOne(
            LumaticaApiManager.call(
                route(
                    "save",
                    firmenId,
                    type,
                    json.encodeToString(All.AllNames.serializer(), data)
                )
            )
        )

    suspend fun delete(type: String, id: String, firmenId: String = currentFirmenId()): Boolean =
        LumaticaApiManager.call(route("delete", firmenId, type, id)).contains("\"ok\":true")

    fun currentFirmenId(): String =
        GlobalManager.currentFirmenId.trim().ifBlank {
            LoginService.getUser()?.firmenId.orEmpty().trim()
        }

    private fun route(action: String, firmenId: String, type: String, payload: String = ""): String =
        buildList {
            add("meinefahrzeuge")
            add(action)
            add(firmenId)
            add(type)
            if (payload.isNotBlank()) add(payload)
        }.joinToString("/") { apiPart(it) }

    private fun decodeOne(raw: String): All? =
        runCatching { json.decodeFromString(All.AllNames.serializer(), raw) }.getOrNull()

    private fun decodeList(raw: String): List<All> =
        runCatching { json.decodeFromString(ListSerializer(All.AllNames.serializer()), raw) }
            .getOrDefault(emptyList())

    private fun apiPart(value: String): String =
        js("encodeURIComponent")(value.ifBlank { EMPTY_FIELD }) as String
}
